import { fetchSameOrigin } from '../Utils';
import React from 'react';

const impersonate = (memberId, deepLinkUrl="/") => {
  const url = `/members/${memberId}/impersonate`;
  return fetchSameOrigin(url, 'POST', { body: JSON.stringify({
    deep_link_path: deepLinkUrl,
  })}).then(r => r.json()).then( ({ impersonation_url })=> {
    window.open(impersonation_url);
    return true;
  })
};
window.impersonate = impersonate;

export default impersonate;
